export default "__VITE_ASSET__CrQFsOi0__"